import { config } from "../../config";
import axios from "axios";

export class EmployeesService {

  public listEmployees = async (): Promise<any[]> => {
    try {
      const { serverUrl } = config;
      const employees = await axios.get(
        serverUrl + "statistics/reports/employee/all"
      );
      return employees.data;
    } catch (err) {
      return [];
    }
  };

  public getEmployeeById = async (id: string): Promise<any> => {
    try {
      const { serverUrl } = config;
      const employees = await axios.get(
        serverUrl + "statistics/reports/employee/all"
      );
      return employees.data.find((item: any) => item.sub === id);
    } catch (err) {
      return {};
    }
  };

  public listEmployeesStats = async (
    id: string,
    from: string,
    to: string,
    filter: string
  ): Promise<any> => {
    try {
      const { serverUrl } = config;
      const type = filter.includes("Month") ? "week" : "day";
      const stats = await axios.get(
        serverUrl + `statistics/reports/user/${id}/${from}/${to}/${type}`
      );
      return stats.data;
    } catch (err) {
      return [];
    }
  };
}